export { default as FolderOutlineIcon } from './FolderOutlineIcon';
